module.exports = __webpack_public_path__ + "static/logo.604f1f1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = ./src/assets/images/logo.svg
// module chunks = 114276838955818